<template>
  <div class="food-tracking">
    <AppHeader></AppHeader>
    <div class="page-wrapper">
      <div class="container-fluid">
        <!-- Title -->
        <div class="row heading-bg clearItems">
          <div class="col-xs-12">
            <h5 class="txt-dark pull-left">
              <button class="btn btn-xs btn-primary" @click="$router.go(-1)">Back to Food Tracking</button>
            </h5>
            <div class="pull-right mg-r-50"></div>
          </div>
        </div>
        <!-- /Title -->
        <h3 class="clearItems">Add food to {{$route.params.meal}}</h3>
        <div class="tab-struct custom-tab-1 mt-40">
          <ul role="tablist" class="nav nav-tabs clearItems" id="myTabs_7">
            <li class="active" role="presentation">
              <a
                aria-expanded="true"
                data-toggle="tab"
                role="tab"
                id="ingredientsSearchTab"
                href="#ingredients_tab"
              >Food</a>
            </li>
            <li role="presentation" class>
              <a
                data-toggle="tab"
                id="recipesSearchTab"
                role="tab"
                href="#recipes_tab"
                aria-expanded="false"
                @click="(searchResultsRecipes.length == 0) ? getRecipes() : null"
              >Recipes</a>
            </li>
            <li role="presentation" class>
              <a
                data-toggle="tab"
                id="recipesSearchTab"
                role="tab"
                href="#my_recipes_tab"
                aria-expanded="false"
              >My Recipes</a>
            </li>
            <li role="presentation" class>
              <a
                data-toggle="tab"
                id="favouritesTab"
                role="tab"
                href="#my_favourites_tab"
                aria-expanded="false"
              >My Favourites</a>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent_7">
            <div id="ingredients_tab" class="tab-pane fade active in clearItems" role="tabpanel">
              <div class="row" v-if="!ingredientChosen">
                <div class="form-group col-md-5">
                  <input
                    type="text"
                    v-model="searchTerm"
                    v-on:keyup.13="currentPage=1; getFood()"
                    class="form-control"
                    placeholder="Search our food database by name"
                  >
                </div>
                <div class="form-group col-md-5">
                  <select
                    class="form-control"
                    v-model="searchFoodLabel"
                    @change="getFood(); currentPage = 1;"
                  >
                    <option value="0">Choose Category (Optional)</option>
                    <option
                      @click="getFood()"
                      v-for="(value, index) in food_labels"
                      :key="index"
                      :value="value.id"
                    >{{value.name}}</option>
                  </select>
                </div>
                <div class="form-group col-md-2">
                  <button
                    class="btn full-width btn-nutri-green"
                    @click="currentPage=1; getFood()"
                  >Search</button>
                </div>
              </div>
              <div v-if="searchResults && !ingredientChosen">
                <div class="row">
                  <div id="searchResultsContainer" v-if="searchResults != null">
                    <h6>Matching Foods:</h6>
                    <div class="mathing-foods-grid">
                      <div class="matching-food-item" v-for="(item, index) in searchResults" :key="index">
                        <span v-if="item.is_user_favourite">
                          <i class="fa fa-heart" style="color:red" title="Favourite"></i>&nbsp;
                        </span>
                        <a
                          href="javascript:void(0)"
                          v-html="item.name"
                          v-on:click="loadChosenIngredient(item.id)"
                        ></a>
                      </div>
                    </div>
                  </div>
                  <div
                    class="alert-info"
                    v-if="searching"
                    style="text-align:center;padding:5px;margin-bottom:5px;"
                  >Loading Ingredients...</div>
                  <a
                    href="javascript:void(0)"
                    v-on:click="currentPage++; getFood()"
                    class="btn btn-nutri-green form-control"
                  >Load More</a>
                </div>
              </div>

              <div v-if="!searchResults && !ingredientChosen" class="col-xs-12">
                <div>
                  <div class="row">
                    <div id="recentfoods" class="col-md-6" style="padding: 40px;">
                      <div class="row">
                        <div>
                          <h6>Recent Foods:</h6>
                          <ul>
                            <li
                              class="searchResult"
                              v-for="(item, index) in recentFoods"
                              v-bind:key="index"
                              v-on:click="ingredientChosen = item; chosenMeasurement = 0; chosenQuantity = 1"
                            >
                              <span v-if="item.is_user_favourite">
                                <i class="fa fa-heart" style="color:red" title="Favourite"></i>&nbsp;
                              </span>
                              <a
                                href="javascript:void(0)"
                                v-html="item.html_name"
                              ></a>
                              <br>
                              <span v-if="item.minimum_measurement">
                                {{JSON.parse(item.minimum_measurement).measurement_name}}, {{parseFloat(item.nutrients[0].value_per_gram).toFixed(2)}}
                                {{item.nutrients[0].name}}
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div id="frequentfoods" class="col-md-6" style="padding: 40px;">
                      <div class="row">
                        <div>
                          <h6>Frequent Foods:</h6>
                          <ul>
                            <li
                              class="searchResult"
                              v-for="(item, index) in frequentFoods"
                              v-bind:key="index"
                              @click="ingredientChosen = item; chosenMeasurement = 0; chosenQuantity = 1"
                            >
                              <a
                                href="javascript:void(0)"
                                v-html="item.html_name"
                              ></a>
                              <br>
                              <span v-if="item.minimum_measurement">
                                {{JSON.parse(item.minimum_measurement).measurement_name}}, {{parseFloat(item.nutrients[0].value_per_gram).toFixed(2)}}
                                {{item.nutrients[0].name}}
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12 animated fadeIn" v-if="ingredientChosen">
                <div class="panel panel-default card-view panel-refresh">
                  <div class="refresh-container">
                    <div class="la-anim-1"></div>
                  </div>
                  <div class="panel-heading">
                    <div class="pull-left">
                      <h4 class="panel-title txt-light">
                        Add
                        <span v-html="ingredientChosen.html_name"></span>
                        to {{$route.params.meal}}
                      </h4>
                    </div>
                    <div class="pull-right">
                      <button
                          class="btn btn-nutri-green full-width"
                          @click="ingredientChosen = null"
                        >
                          <span class="btn-text">Close</span>
                      </button>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="panel-wrapper collapse in">
                    <div class="panel-body">
                      <div class="col-md-12">
                        <div class="col-md-2">
                          <label for="Quantity">Quantity</label>
                          <input
                            type="number"
                            name="qty"
                            v-model="chosenQuantity"
                            placeholder="Quantity"
                            class="form-control"
                          >
                        </div>
                        <div class="col-md-10">
                          <label for="Quantity">of Measurement</label>
                          <select name id class="form-control" v-model="chosenMeasurement">
                            <option
                              v-for="(item, index) in JSON.parse(ingredientChosen.measurements_data)"
                              v-bind:key="index"
                              v-bind:value="index"
                            >{{item.measurement_name}}</option>
                          </select>
                        </div>
                        <div
                          class="col-md-5 p-5"
                          style="background: #F5FFE1; margin-top: 30px; border-radius: 15px; border-color:#F5FFE1;"
                        >
                          <div class="nutrients-panel">
                            <h5>Nutritional Information</h5>
                            <div class="col-xs-5" style="padding:50px; text-align:center;">
                              <h2 style="text-align:center;">{{nutrients.calories}}</h2>
                              <h4 style="text-align:center;">Calories</h4>
                            </div>
                            <div class="col-xs-7 text-right" style="padding:30px;">
                              <table class="table table-responsive">
                                <tr>
                                  <td class="nutrients-label-bold">Total Fat</td>
                                  <td class="nutrients-value">{{nutrients.total_fat}} g</td>
                                </tr>
                                <tr>
                                  <td class="nutrients-label-small">Sat Fat</td>
                                  <td class="nutrients-value-small">{{nutrients.saturated_fat}} g</td>
                                </tr>
                                <tr>
                                  <td class="nutrients-label-bold">Cholesterol</td>
                                  <td class="nutrients-value">{{nutrients.cholesterol}} g</td>
                                </tr>
                                <tr>
                                  <td class="nutrients-label-bold">Salt</td>
                                  <td class="nutrients-value">{{nutrients.salt}} mg</td>
                                </tr>
                                <tr>
                                  <td class="nutrients-label-bold">Total Carbs</td>
                                  <td class="nutrients-value">{{nutrients.carbohydrates_available}} g</td>
                                </tr>
                                <tr>
                                  <td class="nutrients-label-small">Fibre</td>
                                  <td class="nutrients-value-small">{{nutrients.dietary_fibres}} g</td>
                                </tr>
                                <tr>
                                  <td class="nutrients-label-small">Sugars</td>
                                  <td class="nutrients-value-small">{{nutrients.sugars}} g</td>
                                </tr>
                                <tr>
                                  <td class="nutrients-label-bold">Protein</td>
                                  <td class="nutrients-value">{{nutrients.protein}} g</td>
                                </tr>
                              </table>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-7">
                          <div class="col-md-4 mt-20 mb-20">
                            <button class="btn btn-nutri-green full-width" @click="sendFoodToDiary">
                              <span class="btn-text">Track Food</span>
                            </button>
                          </div>
                          <div class="col-md-4 mt-20 mb-20">
                            <button
                              class="btn btn-nutri-red full-width"
                              v-if="!ingredientChosen.is_user_favourite"
                              @click="addFoodToFavourites(ingredientChosen.id); getFavourites();"
                            >
                              <span class="btn-text">Add To Favourites</span>
                            </button>
                            <button
                              class="btn btn-nutri-red full-width"
                              v-if="ingredientChosen.is_user_favourite"
                              @click="removeFoodFromFavourites(ingredientChosen.id); getFavourites();"
                            >
                              <span class="btn-text">Remove From Favourites</span>
                            </button>
                          </div>
                          <div class="col-md-4 mt-20 mb-20">
                            <button
                              class="btn btn-nutri-blue full-width"
                              @click="sendFoodToShoppingList"
                            >
                              <span class="btn-text">Add to Shopping List</span>
                            </button>
                          </div>
                          <div class="col-md-12">
                            <NutritionalTrafficLight
                              :calories="nutrients.calories"
                              :totalFat="nutrients.total_fat"
                              :saturatedFat="nutrients.saturated_fat"
                              :sugars="nutrients.sugars"
                              :sodium="nutrients.salt"
                              :energyKj="nutrients.energy_kj"
                            ></NutritionalTrafficLight>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 text-center" style="margin-top:40px;"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="recipes_tab" class="tab-pane fade" role="tabpanel">
              <div class="row clearItems">
                <div class="form-group col-md-5">
                  <input
                    type="text"
                    v-model="searchTermRecipe"
                    class="form-control"
                    v-on:keyup.13="currentPage=1; getRecipes()"
                    placeholder="Search our recipes database by name"
                  >
                </div>
                <div class="form-group col-md-5">
                  <select
                    name
                    id
                    class="form-control"
                    v-model="searchRecipeCategory"
                    @change="currentPage=1; getRecipes()"
                  >
                    <option value="0">Choose Category (Optional)</option>
                    <option
                      v-for="(value, index) in recipe_categories"
                      :key="index"
                      :value="value.id"
                    >{{value.name}}</option>
                  </select>
                </div>
                <div class="form-group col-md-2">
                  <button
                    class="btn full-width btn-nutri-green"
                    @click="currentPage=1; getRecipes()"
                  >Search</button>
                </div>
              </div>
              <!-- Vip Modal Popup -->
              <div
                class="modal fade clearItems"
                id="modalVip"
                tabindex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="false"
              >
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="exampleModalLabel">VIP Membership</h5>
                    </div>
                    <div
                      class="modal-body"
                    >To view recipes by categories you must have a VIP membership. Check out our VIP membership by clicking below.</div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-nutri-red" data-dismiss="modal">Cancel</button>
                      <button
                        type="button"
                        class="btn btn-nutri-green"
                        data-dismiss="modal"
                        @click="$router.push('/profile/upgrade')"
                      >Okay</button>
                    </div>
                  </div>
                </div>
              </div>

              <button class="btn clearItems" v-show="false" data-toggle="modal" data-target="#modalVip" ref="modalButton"></button>
              <div class="row">
                <div
                  class="form-group"
                  :class="recipeChosen ? 'col-md-4' : 'col-md-12'"
                  v-if="!recipeChosen"
                >
                  <div class="recipe-search-results-grid">
                    <div class="recipe-search-result-item" v-for="(item, index) in searchResultsRecipes" v-bind:key="index"
                    @click="!$store.getters.user.vip_user ? (searchRecipeCategory != 0 ? $refs.modalButton.click() : loadChosenRecipe(item.id)) : loadChosenRecipe(item.id);">
                      <img :src="item.photo_url == null? 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/No_image_available.svg/1024px-No_image_available.svg.png' : item.photo_url" class="img-responsive" alt="Product Image">
                      <div class="recipe-info">
                        <h6 class="recipe-title">{{item.name}}</h6>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 animated fadeIn" v-if="recipeChosen">
                  <div class="panel panel-default card-view panel-refresh">
                    <div class="refresh-container">
                      <div class="la-anim-1"></div>
                    </div>
                    <div class="panel-heading clearItems">
                      <div class="pull-left">
                        <h4 class="panel-title txt-light">
                          Add
                          <span v-html="recipeChosen.name"></span>
                          to {{$route.params.meal}}
                        </h4>
                      </div>
                      <div class="pull-right">
                        <button
                          class="btn btn-nutri-green full-width"
                          @click="recipeChosen = null"
                        >
                          <span class="btn-text">Close</span>
                        </button>
                      </div>
                      <div class="clearfix"></div>
                    </div>
                    <!-- printing page -->
                    <div class="panel-wrapper collapse in" id="print-recipe">
                      <div class="panel-body">
                        <div class="col-md-3">
                          <div class="item-big">
                            <img
                              class="img-responsive"
                              :src="recipeChosen.photo_url == null ? 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/No_image_available.svg/1024px-No_image_available.svg.png' : recipeChosen.photo_url"
                              alt
                            >
                          </div>
                        </div>
                        <div class="col-md-9">
                          <div class="product-detail-wrap">
                            <div class="col-md-6">
                              <h3 class="mb-20 weight-500">{{recipeChosen.name}}</h3>
                              <h5>Ingredients</h5>
                              <div class="form-group" style="margin: 20px 0;">
                                <label for="Quantity" style="font-weight:bold">Number of Servings</label>
                                <input
                                  type="number"
                                  name="qty"
                                  v-model="chosenRecipeQuantity"
                                  placeholder="Quantity"
                                  class="form-control"
                                >
                              </div>
                              <div v-if="recipe_groups.length > 0">
                                <div v-for="(group, key) in recipe_groups" :key="key" style = "margin-top: 20px;">
                                  <h6>{{group}}</h6>
                                  <ul>
                                    <li v-for="(ingredient, key) in chosenRecipeIngredients" :key="key">
                                      {{((ingredient.specified_qty / recipeChosen.servings) * chosenRecipeQuantity).toFixed(2)}} x {{JSON.parse(ingredient.measurements_data)[ingredient.specified_measurement].measurement_name}}
                                      {{ingredient.html_name}}
                                    </li>
                                  </ul>
                                </div>
                              </div>
                              <ul v-else>
                                <li v-for="(ingredient, key) in chosenRecipeIngredients" :key="key">
                                  {{((ingredient.specified_qty / recipeChosen.servings) * chosenRecipeQuantity).toFixed(2)}} x {{JSON.parse(ingredient.measurements_data)[ingredient.specified_measurement].measurement_name}}
                                  {{ingredient.html_name}}
                                </li>
                              </ul>
                            </div>
                            <div class="col-md-6">
                              <div
                                class="col-md-12 p-5"
                                style="background: #F5FFE1; margin-bottom: 30px; border-radius: 15px; border-color:#F5FFE1;"
                              >
                                <div class="nutrients-panel">
                                  <h5>Nutritional Information</h5>
                                  <div class="col-xs-5" style="padding:50px; text-align:center;">
                                    <h2 style="text-align:center;">{{recipeNutrients.calories}}</h2>
                                    <h4 style="text-align:center;">Calories</h4>
                                  </div>
                                  <div class="col-xs-7 text-right" style="padding:30px;">
                                    <table class="table table-responsive">
                                      <tr>
                                        <td class="nutrients-label-bold">Total Fat</td>
                                        <td class="nutrients-value">{{recipeNutrients.total_fat}} g</td>
                                      </tr>
                                      <tr>
                                        <td class="nutrients-label-small">Sat Fat</td>
                                        <td
                                          class="nutrients-value-small"
                                        >{{recipeNutrients.saturated_fat}} g</td>
                                      </tr>
                                      <tr>
                                        <td class="nutrients-label-bold">Cholesterol</td>
                                        <td
                                          class="nutrients-value"
                                        >{{recipeNutrients.cholesterol}} g</td>
                                      </tr>
                                      <tr>
                                        <td class="nutrients-label-bold">Salt</td>
                                        <td class="nutrients-value">{{recipeNutrients.salt}} mg</td>
                                      </tr>
                                      <tr>
                                        <td class="nutrients-label-bold">Total Carbs</td>
                                        <td
                                          class="nutrients-value"
                                        >{{recipeNutrients.total_carbohydrates}} g</td>
                                      </tr>
                                      <tr>
                                        <td class="nutrients-label-small">Fibre</td>
                                        <td
                                          class="nutrients-value-small"
                                        >{{recipeNutrients.dietary_fibres}} g</td>
                                      </tr>
                                      <tr>
                                        <td class="nutrients-label-small">Sugars</td>
                                        <td
                                          class="nutrients-value-small"
                                        >{{recipeNutrients.sugars}} g</td>
                                      </tr>
                                      <tr>
                                        <td class="nutrients-label-bold">Protein</td>
                                        <td class="nutrients-value">{{recipeNutrients.protein}} g</td>
                                      </tr>
                                    </table>
                                  </div>
                                </div>
                              </div>
                              <!-- <NutritionalTrafficLight
                                :calories="recipeNutrients.calories"
                                :totalFat="recipeNutrients.total_fat"
                                :saturatedFat="recipeNutrients.saturated_fat"
                                :sugars="recipeNutrients.sugars"
                                :sodium="recipeNutrients.salt"
                                :energyKj="recipeNutrients.energy_kj"
                              ></NutritionalTrafficLight> -->
                            </div>

                            <div class="col-md-12">
                              <hr>
                              <h5>Directions</h5>
                              <div
                                class="recipe_directions"
                                v-html="recipeChosen.instruction_steps"
                              ></div>
                              <hr>
                            </div>
                          </div>
                        </div>
                        <div class="text-center col-lg-12 clearItems">
                          <div class="col-md-3">
                            <button
                              class="btn btn-nutri-green full-width"
                              @click="sendRecipeToDiary"
                            >
                              <span class="btn-text">Track Recipe</span>
                            </button>
                          </div>
                          <div class="col-md-3">
                            <button
                              class="btn full-width btn-nutri-blue"
                              @click="sendRecipeToShoppingList"
                            >
                              <span class="btn-text">Add to Shopping List</span>
                            </button>
                          </div>
                          <div class="col-md-3">
                            <button
                              class="btn full-width btn-nutri-red"
                              v-if="!recipeChosen.is_user_favourite"
                              @click="addRecipeToFavourites(recipeChosen.id); getFavourites();"
                            >
                              <span class="btn-text">Add To Favourites</span>
                            </button>
                            <button
                              class="btn btn-default full-width"
                              v-if="recipeChosen.is_user_favourite"
                              @click="removeRecipeFromFavourites(recipeChosen.id); getFavourites();"
                            >
                              <i class="fa fa-heart-o"></i>
                              <span class="btn-text">Remove From Favourites</span>
                            </button>
                          </div>
                          <div class="col-md-3">
                            <button
                              class="btn full-width btn-nutri-blue" 
                              @click="printRecipe('print')"
                            >
                              <span class="btn-text">Print Recipe</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- pringing page end -->
                  </div>
                </div>
              </div>
              <a
                v-if="searchResultsRecipes != null && currentPage != recipesLastPage && !recipeChosen"
                href="javascript:void(0)"
                @click="currentPage++; getRecipes()"
                class="btn btn-nutri-green form-control clearItems"
                style="color:white;"
              >Load More</a>
            </div>
            <div id="my_ingredients_tab" class="tab-pane fade clearItems" role="tabpanel">
              <div class="col-md-12">
                <button
                  class="btn btn-nutri-green pull-right"
                  data-toggle="modal"
                  data-target="#newIngredientModal"
                >
                  <span class="btn-text">New Ingredient</span>
                </button>
                <p v-if="customIngredients.length == 0">There are no ingredients to show.</p>
              </div>
              <div v-if="!customIngredientChosen" class="col-md-12">
                <div class="row">
                  <div id="searchResultsContainer" v-if="customIngredients != null">
                    <ul>
                      <li
                        class="searchResult"
                        v-for="(item, index) in customIngredients"
                        v-bind:key="index"
                      >
                        <a
                          href="javascript:void(0)"
                          v-html="item.html_name"
                          v-on:click="customIngredientChosen = item; chosenMeasurement = 0; chosenQuantity = 1"
                        ></a>
                        <br>
                        <span v-if="item.minimum_measurement">
                          {{JSON.parse(item.minimum_measurement).measurement_name}},
                          <span
                            v-if="item.nutrients[0]"
                          >
                            {{parseFloat(item.nutrients[0].value_per_gram).toFixed(2)}}
                            {{item.nutrients[0].name}}
                          </span>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <!-- Replacing -->
              <div class="col-md-12 animated fadeIn" v-if="customIngredientChosen">
                <div class="panel panel-default card-view panel-refresh">
                  <div class="refresh-container">
                    <div class="la-anim-1"></div>
                  </div>
                  <div class="panel-heading">
                    <div class="pull-left">
                      <h4 class="panel-title txt-light">
                        Add
                        <span v-html="customIngredientChosen.html_name"></span>
                        to {{$route.params.meal}}
                      </h4>
                    </div>
                    <div class="pull-right">
                      <button
                          class="btn btn-nutri-green full-width"
                          @click="customIngredientChosen = null"
                        >
                          <span class="btn-text">Close</span>
                        </button>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="panel-wrapper collapse in">
                    <div class="panel-body">
                      <div class="col-md-12">
                        <div class="col-md-2">
                          <label for="Quantity">Quantity</label>
                          <input
                            type="number"
                            name="qty"
                            v-model="chosenQuantity"
                            placeholder="Quantity"
                            class="form-control"
                          >
                        </div>
                        <div class="col-md-10">
                          <label for="Quantity">of Measurement</label>
                          <select name id class="form-control" v-model="chosenMeasurement">
                            <option
                              v-for="(item, index) in JSON.parse(customIngredientChosen.measurements_data)"
                              v-bind:key="index"
                              v-bind:value="index"
                            >{{item.measurement_name}}</option>
                          </select>
                        </div>
                        <div
                          class="col-md-5 p-5"
                          style="background: #F5FFE1; margin-top: 30px; border-radius: 15px; border-color:#F5FFE1;"
                        >
                          <div class="nutrients-panel">
                            <h5>Nutritional Information</h5>
                            <div class="col-xs-5" style="padding:50px; text-align:center;">
                              <h2 style="text-align:center;">{{customIngredientNutrients.calories}}</h2>
                              <h4 style="text-align:center;">Calories</h4>
                            </div>
                            <div class="col-xs-7 text-right" style="padding:30px;">
                              <table class="table table-responsive">
                                <tr>
                                  <td class="nutrients-label-bold">Total Fat</td>
                                  <td
                                    class="nutrients-value"
                                  >{{customIngredientNutrients.total_fat}} g</td>
                                </tr>
                                <tr>
                                  <td class="nutrients-label-small">Sat Fat</td>
                                  <td
                                    class="nutrients-value-small"
                                  >{{customIngredientNutrients.saturated_fat}} g</td>
                                </tr>
                                <tr>
                                  <td class="nutrients-label-bold">Cholesterol</td>
                                  <td
                                    class="nutrients-value"
                                  >{{customIngredientNutrients.cholesterol}} g</td>
                                </tr>
                                <tr>
                                  <td class="nutrients-label-bold">Salt</td>
                                  <td class="nutrients-value">{{customIngredientNutrients.salt}} mg</td>
                                </tr>
                                <tr>
                                  <td class="nutrients-label-bold">Total Carbs</td>
                                  <td
                                    class="nutrients-value"
                                  >{{customIngredientNutrients.total_carbohydrates}} g</td>
                                </tr>
                                <tr>
                                  <td class="nutrients-label-small">Fibre</td>
                                  <td
                                    class="nutrients-value-small"
                                  >{{customIngredientNutrients.dietary_fibres}} g</td>
                                </tr>
                                <tr>
                                  <td class="nutrients-label-small">Sugars</td>
                                  <td
                                    class="nutrients-value-small"
                                  >{{customIngredientNutrients.sugars}} g</td>
                                </tr>
                                <tr>
                                  <td class="nutrients-label-bold">Protein</td>
                                  <td
                                    class="nutrients-value"
                                  >{{customIngredientNutrients.protein}} g</td>
                                </tr>
                              </table>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-7">
                          <div class="col-md-12 mt-40">
                            <img
                              class="img-responsive"
                              :src="'dist/img/alkalinebar/' + customIngredientChosen.alkaline_acidic_measurement + '.png'"
                              alt
                            >
                          </div>
                          <div class="col-md-12 mt-40" v-if="customIngredientChosen.gi_measurement">
                            <img
                              class="img-responsive"
                              :src="'dist/img/gibar/' + customIngredientChosen.gi_measurement + '.png'"
                              alt
                            >
                          </div>
                          <div class="col-md-12">
                            <NutritionalTrafficLight
                              :calories="customIngredientNutrients.calories"
                              :totalFat="customIngredientNutrients.total_fat"
                              :saturatedFat="customIngredientNutrients.saturated_fat"
                              :sugars="customIngredientNutrients.sugars"
                              :sodium="customIngredientNutrients.salt"
                              :energyKj="customIngredientNutrients.energy_kj"
                            ></NutritionalTrafficLight>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 text-center" style="margin-top:40px;"></div>

                      <div class="text-center">
                        <div class="col-md-4">
                          <button
                            class="btn btn-nutri-green full-width"
                            @click="sendCustomIngredientFoodToDiary"
                          >
                            <span class="btn-text">Track Food</span>
                          </button>
                        </div>
                        <div class="col-md-4">
                          <button
                            class="btn btn-nutri-red full-width"
                            v-if="!customIngredientChosen.is_user_favourite"
                            @click="addFoodToFavourites(customIngredientChosen.id); getFavourites();"
                          >
                            <span class="btn-text">Add To Favourites</span>
                          </button>
                          <button
                            class="btn btn-nutri-red full-width"
                            v-if="customIngredientChosen.is_user_favourite"
                            @click="removeFoodFromFavourites(customIngredientChosen.id); getFavourites();"
                          >
                            <span class="btn-text">Remove From Favourites</span>
                          </button>
                        </div>
                        <div class="col-md-4">
                          <button
                            class="btn btn-nutri-blue full-width"
                            @click="sendFoodToShoppingList"
                          >
                            <span class="btn-text">Add to Shopping List</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Replacing ends -->
            </div>
            <div id="my_recipes_tab" class="tab-pane fade clearItems" role="tabpanel">
              <div class="col-md-12">
                <router-link to="/customrecipe" class="btn btn-nutri-green pull-right">
                  <span class="btn-text">New Recipe</span>
                </router-link>
                <p v-if="customRecipes.length == 0">There are no recipes to show.</p>
              </div>
              <div class="row">
                <div class="form-group" :class="recipeChosen ? 'col-md-4' : 'col-md-12'">

                  <div class="recipe-search-results-grid">
                    <div class="recipe-search-result-item" v-for="(item, index) in customRecipes" v-bind:key="index" @click="loadChosenRecipe(item.id)">
                      <img :src="item.photo_url == null? 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/No_image_available.svg/1024px-No_image_available.svg.png' : item.photo_url" class="img-responsive" alt="Product Image">
                      <div class="recipe-info">
                        <h6 class="recipe-title">{{item.name}}</h6>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-8 animated fadeIn" v-if="recipeChosen">
                  <div class="panel panel-default card-view panel-refresh">
                    <div class="refresh-container">
                      <div class="la-anim-1"></div>
                    </div>
                    <div class="panel-heading">
                      <div class="pull-left">
                        <h4 class="panel-title txt-light">
                          Add
                          <span v-html="recipeChosen.name"></span>
                          to {{$route.params.meal}}
                        </h4>
                      </div>
                      <div class="pull-right">
                        <button
                          class="btn btn-nutri-green full-width"
                          @click="recipeChosen = null"
                        >
                          <span class="btn-text">Close</span>
                        </button>
                      </div>
                      <div class="clearfix"></div>
                    </div>
                    <div class="panel-wrapper collapse in">
                      <div class="panel-body">
                        <div class="col-md-3">
                          <div class="item-big">
                            <img
                              class="img-responsive"
                              :src="recipeChosen.photo_url == null ? 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/No_image_available.svg/1024px-No_image_available.svg.png' : recipeChosen.photo_url"
                              alt
                            >
                          </div>
                        </div>
                        <div class="col-md-9">
                          <div class="product-detail-wrap">
                            <h3 class="mb-20 weight-500">{{recipeChosen.name}}</h3>
                            <h5>Ingredients</h5>
                            <ul>
                              <li v-for="(ingredient, key) in chosenRecipeIngredients" :key="key">
                                {{((ingredient.specified_qty / recipeChosen.servings) * chosenRecipeQuantity).toFixed(2)}} x {{JSON.parse(ingredient.measurements_data)[ingredient.specified_measurement].measurement_name}}
                                {{ingredient.html_name}}
                              </li>
                            </ul>
                            <h5>Directions</h5>
                            {{recipeChosen.instruction}}
                          </div>
                        </div>
                        <div class="form-group col-md-3 col-sm-offset-3">
                          <label for="Quantity">Number of Servings</label>
                          <input
                            type="number"
                            name="qty"
                            v-model="chosenRecipeQuantity"
                            placeholder="Quantity"
                            class="form-control"
                          >
                        </div>
                        <!-- <div class="col-md-12 text-center" style="margin-top:40px;">
                          <h5>Nutritional Information</h5>
                          <div class="col-md-12">
                            <NutritionalTrafficLight
                              :calories="recipeNutrients.calories"
                              :totalFat="recipeNutrients.total_fat"
                              :saturatedFat="recipeNutrients.saturated_fat"
                              :sugars="recipeNutrients.sugars"
                              :sodium="recipeNutrients.salt"
                              :energyKj="recipeNutrients.energy_kj"
                            ></NutritionalTrafficLight>
                          </div>
                        </div> -->
                        <div class="col-md-12 text-right" style="margin-top:40px;">
                          <input
                            type="button"
                            @click="sendRecipeToDiary"
                            class="btn btn-nutri-green"
                            value="Add Recipe"
                          >
                          &nbsp;&nbsp;
                          <input
                            type="button"
                            @click="sendRecipeToShoppingList"
                            class="btn btn-nutri-green"
                            value="Add To Shopping List"
                          >
                          &nbsp;&nbsp;
                          <input
                            type="button"
                            @click="deleteRecipe"
                            class="btn btn-nutri-red"
                            value="Remove Recipe"
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="my_favourites_tab" class="tab-pane fade" role="tabpanel">
              <div class="col-md-12 clearItems">
                <h5 style="margin-bottom:10px;" class="clearItems">Favourite Ingredients</h5>
                <p
                  class="clearItems"
                  v-if="favouriteIngredients.length == 0"
                  style="margin-bottom:12px;margin-top:15px;"
                >There are no favourite ingredients to show.</p>
                <ul>
                  <li
                    class="searchResult clearItems"
                    v-for="(item, index) in favouriteIngredients"
                    v-bind:key="index"
                  >
                    <span v-if="item.is_user_favourite">
                      <i class="fa fa-heart" style="color:red" title="Favourite"></i>&nbsp;
                    </span>
                    <a
                      href="javascript:void(0)"
                      v-html="item.html_name"
                      v-on:click="ingredientChosen = item; chosenMeasurement = 0; chosenQuantity = 1"
                    ></a>
                    <br>
                    <span v-if="item.minimum_measurement">
                      {{JSON.parse(item.minimum_measurement).measurement_name}}, {{parseFloat(item.nutrients[0].value_per_gram).toFixed(2)}}
                      {{item.nutrients[0].name}}
                    </span>
                  </li>
                </ul>
                <div class="col-md-8 animated fadeIn clearItems" v-if="ingredientChosen">
                  <div class="panel panel-default card-view panel-refresh">
                    <div class="refresh-container">
                      <div class="la-anim-1"></div>
                    </div>
                    <div class="panel-heading">
                      <div class="pull-left">
                        <h4 class="panel-title txt-light">
                          Add
                          <span v-html="ingredientChosen.html_name"></span>
                          to {{$route.params.meal}}
                        </h4>
                      </div>
                      <div class="pull-right">
                        <button
                          class="btn btn-nutri-green full-width"
                          @click="ingredientChosen = null"
                        >
                          <span class="btn-text">Close</span>
                        </button>
                      </div>
                      <div class="clearfix"></div>
                    </div>
                    <div class="panel-wrapper collapse in">
                      <div class="panel-body">
                        <div class="col-md-2">
                          <label for="Quantity">Quantity</label>
                          <input
                            type="number"
                            name="qty"
                            v-model="chosenQuantity"
                            placeholder="Quantity"
                            class="form-control"
                          >
                        </div>
                        <div class="col-md-10">
                          <label for="Quantity">of Measurement</label>
                          <select name id class="form-control" v-model="chosenMeasurement">
                            <option
                              v-for="(item, index) in JSON.parse(ingredientChosen.measurements_data)"
                              v-bind:key="index"
                              v-bind:value="index"
                            >{{item.measurement_name}}</option>
                          </select>
                        </div>
                        <div class="col-md-12 text-center" style="margin-top:40px;">
                          <h5>Nutritional Information</h5>
                          <div class="col-md-12">
                            <NutritionalTrafficLight
                              :calories="nutrients.calories"
                              :totalFat="nutrients.total_fat"
                              :saturatedFat="nutrients.saturated_fat"
                              :sugars="nutrients.sugars"
                              :sodium="nutrients.salt"
                              :energyKj="nutrients.energy_kj"
                            ></NutritionalTrafficLight>
                          </div>
                        </div>
                        <div class="text-center">
                          <div class="col-md-4">
                            <button class="btn btn-success full-width" @click="sendFoodToDiary">
                              <i class="fa fa-cutlery"></i>
                              <span class="btn-text">Track Food</span>
                            </button>
                          </div>
                          <div class="col-md-4">
                            <button
                              class="btn btn-success full-width"
                              @click="sendFoodToShoppingList"
                            >
                              <i class="fa fa-shopping-cart"></i>
                              <span class="btn-text">Add to Shopping List</span>
                            </button>
                          </div>
                          <div class="col-md-4">
                            <button
                              class="btn btn-danger full-width"
                              v-if="!ingredientChosen.is_user_favourite"
                              @click="addFoodToFavourites(ingredientChosen.id)"
                            >
                              <i class="fa fa-heart"></i>
                              <span class="btn-text">Add To Favourites</span>
                            </button>
                            <a
                              href="#"
                              class="btn btn-default full-width"
                              v-if="ingredientChosen.is_user_favourite"
                              data-toggle="modal"
                              @click="temp_id = ingredientChosen.id"
                              data-target="#exampleModal"
                            >
                              <i class="fa fa-heart-o"></i>
                              <span class="btn-text">Remove From Favourites</span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="modal fade"
                id="exampleModal"
                tabindex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Remove Favourite Ingredient</h5>
                  </div>
                  <div class="modal-body">
                    Are you sure you want to remove this ingredient from favourites?
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-nutri-red" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-nutri-green" data-dismiss="modal" @click="removeFoodFromFavourites(temp_id); getFavourites();">Okay</button>
                  </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <h5 style="margin-bottom:10px;" class="clearItems">Favourite Recipes</h5>
                <p
                  class="clearItems"
                  v-if="favouriteRecipes.length == 0"
                  style="margin-bottom:12px;margin-top:15px;"
                >There are no favourite recipes to show.</p>
                <div
                  style="padding-left:0px;margin-left:-10px;"
                  class="form-group"
                  :class="recipeChosen ? 'col-md-4' : 'col-md-12'"
                  v-if="!recipeChosen"
                >
                  <div class="recipe-search-results-grid">
                    <div class="recipe-search-result-item" v-for="(item, index) in favouriteRecipes" v-bind:key="index"
                    @click="!$store.getters.user.vip_user ? (searchRecipeCategory != 0 ? $refs.modalButton.click() : loadChosenRecipe(item.id)) : loadChosenRecipe(item.id); chosenRecipeQuantity = item.servings">
                      <img :src="item.photo_url == null? 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/No_image_available.svg/1024px-No_image_available.svg.png' : item.photo_url" class="img-responsive" alt="Product Image">
                      <div class="recipe-info">
                        <h6 class="recipe-title">{{item.name}}</h6>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 animated fadeIn" v-if="recipeChosen">
                    <div class="panel panel-default card-view panel-refresh">
                      <div class="refresh-container">
                        <div class="la-anim-1"></div>
                      </div>
                      <div class="panel-heading clearItems">
                        <div class="pull-left">
                          <h4 class="panel-title txt-light">
                            Add
                            <span v-html="recipeChosen.name"></span>
                            to {{$route.params.meal}}
                          </h4>
                        </div>
                        <div class="pull-right">
                          <button
                            class="btn-nutri-green full-width"
                            @click="recipeChosen = null"
                          >
                            <span class="btn-text">Close</span>
                          </button>
                        </div>
                        <div class="clearfix"></div>
                      </div>
                      <div class="panel-wrapper collapse in">
                        <div class="panel-body">
                          <div class="col-md-3">
                            <div class="item-big">
                              <img
                                class="img-responsive"
                                :src="recipeChosen.photo_url == null ? 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/No_image_available.svg/1024px-No_image_available.svg.png' : recipeChosen.photo_url"
                                alt
                              >
                            </div>
                          </div>
                          <div class="col-md-9">
                            <div class="product-detail-wrap">
                              <div class="col-md-6">
                                <h3 class="mb-20 weight-500">{{recipeChosen.name}}</h3>
                                <h5>Ingredients</h5>
                                <ul>
                                  <li
                                    v-for="(ingredient, key) in chosenRecipeIngredients"
                                    :key="key"
                                  >
                                    {{((ingredient.specified_qty / recipeChosen.servings) * chosenRecipeQuantity).toFixed(2)}} x {{JSON.parse(ingredient.measurements_data)[0].measurement_name}}
                                    {{ingredient.html_name}}
                                  </li>
                                </ul>
                              </div>
                              <div class="col-md-6">
                                <div
                                  class="col-md-12 p-5"
                                  style="background: #F5FFE1; margin-bottom: 30px; border-radius: 15px; border-color:#F5FFE1;"
                                >
                                  <div class="nutrients-panel">
                                    <h5>Nutritional Information</h5>
                                    <div class="col-xs-5" style="padding:50px; text-align:center;">
                                      <h2 style="text-align:center;">{{recipeNutrients.calories}}</h2>
                                      <h4 style="text-align:center;">Calories</h4>
                                    </div>
                                    <div class="col-xs-7 text-right" style="padding:30px;">
                                      <table class="table table-responsive">
                                        <tr>
                                          <td class="nutrients-label-bold">Total Fat</td>
                                          <td
                                            class="nutrients-value"
                                          >{{recipeNutrients.total_fat}} g</td>
                                        </tr>
                                        <tr>
                                          <td class="nutrients-label-small">Sat Fat</td>
                                          <td
                                            class="nutrients-value-small"
                                          >{{recipeNutrients.saturated_fat}} g</td>
                                        </tr>
                                        <tr>
                                          <td class="nutrients-label-bold">Cholesterol</td>
                                          <td
                                            class="nutrients-value"
                                          >{{recipeNutrients.cholesterol}} g</td>
                                        </tr>
                                        <tr>
                                          <td class="nutrients-label-bold">Salt</td>
                                          <td class="nutrients-value">{{recipeNutrients.salt}} mg</td>
                                        </tr>
                                        <tr>
                                          <td class="nutrients-label-bold">Total Carbs</td>
                                          <td
                                            class="nutrients-value"
                                          >{{recipeNutrients.total_carbohydrates}} g</td>
                                        </tr>
                                        <tr>
                                          <td class="nutrients-label-small">Fibre</td>
                                          <td
                                            class="nutrients-value-small"
                                          >{{recipeNutrients.dietary_fibres}} g</td>
                                        </tr>
                                        <tr>
                                          <td class="nutrients-label-small">Sugars</td>
                                          <td
                                            class="nutrients-value-small"
                                          >{{recipeNutrients.sugars}} g</td>
                                        </tr>
                                        <tr>
                                          <td class="nutrients-label-bold">Protein</td>
                                          <td class="nutrients-value">{{recipeNutrients.protein}} g</td>
                                        </tr>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                                <!-- <NutritionalTrafficLight
                                  :calories="recipeNutrients.calories"
                                  :totalFat="recipeNutrients.total_fat"
                                  :saturatedFat="recipeNutrients.saturated_fat"
                                  :sugars="recipeNutrients.sugars"
                                  :sodium="recipeNutrients.salt"
                                  :energyKj="recipeNutrients.energy_kj"
                                ></NutritionalTrafficLight> -->
                              </div>

                              <div class="col-md-12">
                                <hr>
                                <h5>Directions</h5>
                                <div
                                  class="recipe_directions"
                                  v-html="recipeChosen.instruction_steps"
                                ></div>
                                <hr>
                              </div>
                            </div>
                          </div>
                          <div class="form-group col-lg-2 clearItems">
                            <label for="Quantity" style="font-weight:bold">Number of Servings</label>
                            <input
                              type="number"
                              name="qty"
                              v-model="chosenRecipeQuantity"
                              placeholder="Quantity"
                              class="form-control"
                            >
                          </div>
                          <div class="text-center col-lg-10 clearItems" style="margin-top:22px;">
                            <div class="col-md-3">
                              <button
                                class="btn btn-nutri-green full-width"
                                @click="sendRecipeToDiary"
                              >
                                <span class="btn-text">Track Recipe</span>
                              </button>
                            </div>
                            <div class="col-md-3">
                              <button
                                v-if="$store.getters.user.vip_user"
                                class="btn full-width btn-nutri-blue"
                                @click="sendRecipeToShoppingList"
                              >
                                <span class="btn-text">Add to Shopping List</span>
                              </button>
                              <a 
                                v-if="!$store.getters.user.vip_user"
                                class="btn btn-orange"
                              >
                                <span class="btn-text">Upgrade to use Shopping List</span>
                              </a>
                            </div>
                            <div class="col-md-3">
                              <button
                                class="btn full-width btn-nutri-red"
                                v-if="!recipeChosen.is_user_favourite"
                                @click="addRecipeToFavourites(recipeChosen.id)"
                              >
                                <span class="btn-text">Add To Favourites</span>
                              </button>
                              <button
                                class="btn btn-default full-width"
                                v-if="recipeChosen.is_user_favourite"
                                data-toggle="modal"
                                @click="temp_id = recipeChosen.id"
                                data-target="#exampleModal2"
                              >
                                <i class="fa fa-heart-o"></i>
                                <span class="btn-text">Remove From Favourites</span>
                              </button>
                            </div>
                            <div class="col-md-3">
                              <button
                                class="btn full-width btn-nutri-blue"
                                @click="printRecipe('print')"
                              >
                                <span class="btn-text">Print Recipe</span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="modal fade"
                id="exampleModal2"
                tabindex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="false"
              >
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="exampleModalLabel">Remove Favourite Recipe</h5>
                    </div>
                    <div
                      class="modal-body"
                    >Are you sure you want to remove this recipe from favourites?</div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-nutri-red" data-dismiss="modal">Cancel</button>
                      <button
                        type="button"
                        class="btn btn-nutri-green"
                        data-dismiss="modal"
                        @click="removeRecipeFromFavourites(temp_id)"
                      >Okay</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <AppFooter></AppFooter>
    <loading :active.sync="isLoading"></loading>
  </div>
</template>

<script>
import API from "../../services/api.js";
import AppHeader from "../../components/common/AppHeader.vue";
import AppFooter from "../../components/common/AppFooter.vue";
import Paginate from "vuejs-paginate";
import swal from "sweetalert";
import Datepicker from "vuejs-datepicker";
import NutritionalTrafficLight from "../../components/common/TrafficLights.vue";
import Loading from 'vue-loading-overlay';
	// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import { Datetime } from 'vue-datetime'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'

const api = new API();

export default {
  components: {
    AppHeader,
    AppFooter,
    Paginate,
    swal,
    Datepicker,
    NutritionalTrafficLight,
    Loading,
    Datetime
  },
  data() {
    return {
      recipe_groups: [], 
      vip_popup: false,
      isLoading: false,
      searchTerm: null,
      searchFoodLabel: 0,
      searchResults: null,
      currentPage: 1,
      ingredientChosen: null,
      chosenMeasurement: 0,
      chosenQuantity: 1,
      mealTypeId: 0,
      searching: false,
      date: this.$store.getters.globalDate,
      searchTermRecipe: null,
      searchResultsRecipes: [],
      recipeChosen: null,
      chosenRecipeIngredients: [],
      chosenRecipeQuantity: 1,
      recentFoods: [],
      frequentFoods: [],
      food_labels: [],
      newIngredient: null,
      newIngredientFoodLabels: [],
      newIngredientNutrients: [
        { nutrient_id: "1", name: "Calories" },
        { nutrient_id: "4", name: "Total Fat" },
        { nutrient_id: "5", name: "Saturated Fat" },
        { nutrient_id: "8", name: "Colesterol" },
        { nutrient_id: "12", name: "Sodium" },
        { nutrient_id: "9", name: "Total Carbs" },
        { nutrient_id: "10", name: "Fibre" },
        { nutrient_id: "11", name: "Sugars" },
        { nutrient_id: "3", name: "Protein" }
      ],
      newIngredientServingSize: null,
      newIngredientServingUnits: null,
      newIngredientPhoto: null,
      customIngredients: [],
      customIngredientChosen: null,
      customRecipes: [],
      recipe_categories: null,
      searchRecipeCategory: 0,
      favouriteRecipes: [],
      favouriteIngredients: [],
      newIngredientPackagingDescription: null,
      newIngredientPackagingQuantity: null,
      newIngredientCompany: null,
      newIngredientBarcode: null,
      temp_id: 0,
      recipesLastPage: 0
    };
  },
  methods: {
    printRecipe(print){
      window.print(document.getElementById('print-recipe').innerHTML);
		},
    handleFileUpload() {
      const elem = this.$refs.customIngredientTrack;
      const elem2 = this.$refs.customIngredientClose;
      elem.disabled = true;
      elem2.disabled = true;

      api
        .uploadPhoto("ingredient", this.$refs.file.files[0])
        .then(async response => {
          if (response.data.success) {
            this.newIngredientPhoto = response.data.data;
            elem.disabled = false;
            elem2.disabled = false;
          }
        });
    },
    addCustomIngredient: function() {
      //(packaging_description, company, barcode)
      api
        .addCustomIngredient(
          this.newIngredient,
          this.newIngredientFoodLabels,
          JSON.stringify(this.newIngredientNutrients),
          this.newIngredientPhoto,
          this.newIngredientServingUnits,
          this.newIngredientServingSize,
          this.newIngredientPackagingDescription,
          this.newIngredientPackagingQuantity,
          this.newIngredientCompany,
          this.newIngredientBarcode
        )
        .then(async response => {
          if (response.data.success) {
            swal(
              "Ingredient Created!",
              "Custom Ingredient Created!",
              "success"
            );
            const elem = this.$refs.customIngredientClose;
            elem.click();
            setTimeout(() => {
              swal.close();
            }, 4000);

            this.getCustomIngredients();
          }
        });
    },
    getFoodLabels: function() {
      api.getFoodLabels().then(async response => {
        if (response.data.success) {
          this.food_labels = response.data.data;
        }
      });
    },
    getRecipeCategories: function() {
      api.getRecipeCategories().then(async response => {
        if (response.data.success) {
          this.recipe_categories = response.data.data;
        }
      });
    },
    loadChosenIngredient: function(id) {
      console.log(id);
      api
        .getIngredientById(id)
        .then(async response => {
            this.ingredientChosen = response.data.data;
        });
    },
    loadChosenRecipe: function(id) {
      api
        .getRecipeById(id)
        .then(async response => {
            this.recipeChosen = response.data.data;
            this.chosenRecipeQuantity = this.recipeChosen.servings ? parseInt(this.recipeChosen.servings) : 1;
        });
    },
    getFood: function() {
      this.searching = true;
      if (this.currentPage == 1) {
        this.searchResults = null;
      }
      this.isLoading = true; 
      api
        .searchFood(this.searchTerm, this.searchFoodLabel, this.currentPage)
        .then(async response => {
          if (response.data.success) {
            this.searching = false;
            this.isLoading = false;
            if (this.currentPage == 1) {
              this.searchResults = response.data.data.data;
            } else {
              for (var r = 0; r < response.data.data.data.length; r++) {
                this.searchResults.push(response.data.data.data[r]);
              }
            }
          }
        });
    },
    getRecipes() {
      this.searching = true;
      if (this.currentPage == 1) {
        this.searchResultsRecipes = null;
      }
      this.isLoading = true;
      api
        .searchRecipes(
          this.searchTermRecipe,
          this.searchRecipeCategory,
          this.currentPage
        )
        .then(async response => {
          if (response.data.success) {
            this.searching = false;
            this.isLoading = false;
            this.recipesLastPage = response.data.data.last_page;
            if (this.currentPage == 1) {
              this.searchResultsRecipes = response.data.data.data;
            } else {
              for (var r = 0; r < response.data.data.data.length; r++) {
                this.searchResultsRecipes.push(response.data.data.data[r]);
              }
            }
          }
        });
    },
    sendFoodToDiary: function() {
      api
        .trackFood(
          this.mealTypeId,
          this.ingredientChosen.id,
          this.chosenQuantity,
          this.chosenMeasurement,
          this.date
        )
        .then(async response => {
          if (response.data.success) {
            swal(
              "Food Tracked!",
              "You just tracked " +
                this.ingredientChosen.html_name +
                " to " +
                this.$route.params.meal +
                "!",
              "success"
            );
            setTimeout(() => {
              swal.close();
            }, 4000);
            this.$router.go(-1);
          }
        });
    },
    sendFoodToShoppingList: function() {
      api
        .addFoodToShoppingList(
          this.ingredientChosen.id,
          this.chosenQuantity,
          JSON.parse(this.ingredientChosen.measurements_data)[
            this.chosenMeasurement
          ].measurement_name
        )
        .then(async response => {
          if (response.data.success) {
            swal(
              "Food Added!",
              "You just added " +
                this.ingredientChosen.html_name +
                " to your shopping list!",
              "success"
            );
            setTimeout(() => {
              swal.close();
            }, 4000);
          }
        });
    },
    sendRecipeToShoppingList: function() {
      api
        .addRecipeToShoppingList(
          this.recipeChosen.id,
          this.chosenRecipeQuantity
        )
        .then(async response => {
          if (response.data.success) {
            swal(
              "Recipe Added!",
              "Ingredients in the chosen recipe were added to your shopping list!",
              "success"
            );
            setTimeout(() => {
              swal.close();
            }, 4000);
          }
        });
    },
    sendCustomIngredientFoodToDiary: function() {
      api
        .trackFood(
          this.mealTypeId,
          this.customIngredientChosen.id,
          this.chosenQuantity,
          this.chosenMeasurement,
          this.date
        )
        .then(async response => {
          if (response.data.success) {
            swal(
              "Food Tracked!",
              "You just tracked " +
                this.customIngredientChosen.html_name +
                " to " +
                this.$route.params.meal +
                "!",
              "success"
            );
            setTimeout(() => {
              swal.close();
            }, 4000);
            this.$router.go(-1);
          }
        });
    },
    sendRecipeToDiary: function() {
      api
        .trackRecipe(
          this.mealTypeId,
          this.recipeChosen.id,
          this.chosenRecipeQuantity,
          this.date
        )
        .then(async response => {
          if (response.data.success) {
            swal(
              "Recipe Tracked!",
              "You just tracked " +
                this.recipeChosen.name +
                " to " +
                this.$route.params.meal +
                "!",
              "success"
            );
            setTimeout(() => {
              swal.close();
            }, 4000);
            this.$router.go(-1);
          }
        });
    },
    getFrequentAndRecentIngredients: function() {
      api.getRecentIngredients().then(async response => {
        if (response.data.success) {
          this.recentFoods = response.data.data;
        }
      });

      api.getFrequentIngredients().then(async response => {
        if (response.data.success) {
          this.frequentFoods = response.data.data;
        }
      });
    },
    getCustomIngredients() {
      api.getCustomIngredients().then(async response => {
        if (response.data.success) {
          this.customIngredients = response.data.data;
        }
      });
    },
    getCustomRecipes() {
      api.getCustomRecipes().then(async response => {
        if (response.data.success) {
          this.customRecipes = response.data.data;
        }
      });
    },
    deleteRecipe() {
      api.deleteRecipe(this.recipeChosen.id).then(async response => {
        if (response.data.success) {
          this.customRecipes = response.data.data;
          this.getCustomRecipes();
          this.recipeChosen = null;
          swal("Recipe Deleted!", "Custom Ingredient Deleted!", "success");
          const elem = this.$refs.customIngredientClose;
          elem.click();
          setTimeout(() => {
            swal.close();
          }, 4000);
        }
      });
    },
    addFoodToFavourites(ingredientId) {
      api.addFoodToFavourites(ingredientId).then(async response => {
        if (response.data.success) {
          this.ingredientChosen.is_user_favourite = true;
          swal(
            "Ingredient Added!",
            "Ingredient has been added to your list of favourites!",
            "success"
          );
          const elem = this.$refs.customIngredientClose;
          elem.click();
          setTimeout(() => {
            swal.close();
          }, 4000);
          this.getFavourites();
        }
      });
    },
    removeFoodFromFavourites(ingredientId) {
      api.removeFoodFromFavourites(ingredientId).then(async response => {
        if (response.data.success) {
          this.ingredientChosen.is_user_favourite = false;
          swal(
            "Ingredient Removed!",
            "Ingredient has been removed from your list of favourites!",
            "success"
          );
          const elem = this.$refs.customIngredientClose;
          elem.click();
          setTimeout(() => {
            swal.close();
          }, 4000);
          this.ingredientChosen = null;
          this.getFavourites();
        }
      });
    },
    addRecipeToFavourites(recipeId) {
      api.addRecipeToFavourites(recipeId).then(async response => {
        if (response.data.success) {
          this.recipeChosen.is_user_favourite = true;
          swal(
            "Recipe Added!",
            "Recipe has been added to your list of favourites!",
            "success"
          );
          const elem = this.$refs.customIngredientClose;
          elem.click();
          setTimeout(() => {
            swal.close();
          }, 4000);
          this.getFavourites();
        }
      });
    },
    removeRecipeFromFavourites(recipeId) {
      api.removeRecipeFromFavourites(recipeId).then(async response => {
        if (response.data.success) {
          this.recipeChosen.is_user_favourite = false;
          swal(
            "Recipe Removed!",
            "Recipe has been removed from your list of favourites!",
            "success"
          );
          const elem = this.$refs.customIngredientClose;
          elem.click();
          setTimeout(() => {
            swal.close();
          }, 4000);
          this.recipeChosen = null;
          this.getFavourites();
        }
      });
    },
    getFavourites() {
      api.getFavouriteIngredients().then(async response => {
        if (response.data.success) {
          this.favouriteIngredients = response.data.data.data;
        }

        api.getFavouriteRecipes().then(async response => {
          if (response.data.success) {
            this.favouriteRecipes = response.data.data.data;
          }
        });
      });
    }
  },
  created: function() {
    switch (this.$route.params.meal) {
      case "breakfast":
        this.mealTypeId = 1;
        break;
      case "morning snack":
        this.mealTypeId = 2;
        break;
      case "lunch":
        this.mealTypeId = 3;
        break;
      case "afternoon snack":
        this.mealTypeId = 4;
        break;
      case "dinner":
        this.mealTypeId = 5;
        break;
    }

    this.getFrequentAndRecentIngredients();
    this.getFoodLabels();
    this.getCustomIngredients();
    this.getCustomRecipes();
    this.getRecipeCategories();
    this.getFavourites();
  },
  computed: {
    nutrients: function() {
      let nutrients = {};

      for (var j = 0; j < this.ingredientChosen.nutrients.length; j++) {
        nutrients[
          this.ingredientChosen.nutrients[j].name
            .toLowerCase()
            .replace(/ /g, "_")
        ] = Math.ceil(
          JSON.parse(this.ingredientChosen.measurements_data)[
            this.chosenMeasurement
          ].multiplier_of_minimum *
            this.chosenQuantity *
            this.ingredientChosen.nutrients[j].value_per_gram
        );
      }

      return nutrients;
    },
    customIngredientNutrients: function() {
      let nutrients = {};

      for (var j = 0; j < this.customIngredientChosen.nutrients.length; j++) {
        nutrients[
          this.customIngredientChosen.nutrients[j].name
            .toLowerCase()
            .replace(/ /g, "_")
        ] = Math.ceil(
          JSON.parse(this.customIngredientChosen.measurements_data)[
            this.chosenMeasurement
          ].multiplier_of_minimum *
            this.chosenQuantity *
            this.customIngredientChosen.nutrients[j].value_per_gram
        );
      }

      return nutrients;
    },
    recipeNutrients: function() {
      let nutrients = {};
      for (var key in this.recipeChosen.nutrients_per_serving) {
        if (this.recipeChosen.nutrients_per_serving.hasOwnProperty(key)) {
          var this_nutrient = this.recipeChosen.nutrients_per_serving[key];
          nutrients[this_nutrient.name.toLowerCase().replace(/ /g, "_")] = (
            this.chosenRecipeQuantity * this_nutrient.per_serving
          ).toFixed(0);
        }
      }

      return nutrients;
    }
  },
  watch: {
    recipeChosen: function(recipe) {
      let recipe_ingredients = [];
      let ingredients = JSON.parse(recipe.ingredients_json);
      let comp = this;
      this.recipe_groups = [];

      for (let index = 0; index < ingredients.length; index++) {
        const ingredient = ingredients[index];
        if(ingredient.group) {
          if(!this.recipe_groups.includes(ingredient.group))
            this.recipe_groups.push(ingredient.group);
        }
      }

      this.chosenRecipeIngredients = ingredients;
    }
  }
};
</script>

<style scoped>
@media print {
  .clearItems {
    display: none;
  }
}

.card-shadow:hover{
  box-shadow: 6px 11px 25px 0px rgba(0,0,0,0.3);
}

.card-shadow{
  box-shadow: 6px 11px 25px 0px rgba(0,0,0,0.1);
}

.recipe-info{
  padding-top:10px;
  padding-bottom: 15px;
  padding-right: 15px;
}

.recipe-title{
    font-weight: 400;
    font-size: 18px;
    vertical-align: middle;
}

#searchResultsContainer {
  padding: 5px;
}
.searchResult {
  height: 75px;
  margin: 5px 0;
  font-size: small;
  border: 1px solid #ccc;
  border-radius: 15px;
  padding: 15px;
  background: #f5f5f5;
}

.btn-nutri-green {
  background-color: #7EC347 !important;
  border: 2px solid #4A7F1B !important;
  color: #fff;
  border-radius: 5px !important;
}

.btn-nutri-green:hover {
  background-color: #4A7F1B !important;
  border: 2px solid #4A7F1B !important;
  color: #fff;
  border-radius: 5px !important;
}

.searchResult:hover {
  height: 75px;
  margin: 5px 0;
  font-size: small;
  border: 1px solid #ccc;
  border-radius: 15px;
  padding: 15px;
  background: #feffe8;
  cursor: pointer;
}

#chosenIngredientContainer {
  padding: 20px;
  border: 1px solid #ccc;
}
.recipe {
  padding: 30% 1% 2% 30%;
}

.nutrients-panel {
  margin-top: 30px;
  text-align: center;
  height: 100%;
  width: 100%;
}

.nutrients-panel h2 {
  font-weight: bold;
  font-size: 60px !important;
}

.nutrients-panel h4 {
  font-weight: lighter;
  font-size: 28px !important;
  margin-top: 10px;
}

.nutrients-label-bold {
  font-weight: bold;
}

.nutrients-label-small {
  font-size: 11px;
}

.nutrients-value-small {
  font-size: 11px;
}

p {
  margin: 20px 0 !important;
}

.recipe-search-results-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 20px;
}

@media (max-width: 650px) {
  .recipe-search-results-grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 20px;
  }
}

.mathing-foods-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 20px;
}

@media (max-width: 650px) {
  .mathing-foods-grid {
    grid-template-columns: 1fr 1fr 1fr;
  }
}

.matching-food-item {
  height: 75px;
  margin: 5px 0;
  font-size: small;
  border: 1px solid #ccc;
  border-radius: 15px;
  padding: 15px;
  background: #f5f5f5;
}


.recipe-search-result-item {
  border: 1px solid #ccc;
  padding: 20px;
  border-radius: 10px;
  cursor: pointer;
}

.recipe-search-result-item  img{
  border: 1px solid #eee;
  cursor: pointer;
}

.recipe-search-result-item:hover, .matching-food-item:hover {
  background-color: #F5FFE1;
}
</style>


// WEBPACK FOOTER //
// src/views/FoodTracking/AddFood.vue